import React, { SVGProps } from 'react'

export const HashTagSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill={props.color ? props.color : '#615857'}
      fillRule="evenodd"
      d="M4.34 13.21a1 1 0 0 0 1.985.247L6.633 11h1.984l-.276 2.21a1 1 0 0 0 1.985.247L10.633 11h2.7a1 1 0 1 0 0-2h-2.45l.25-2h2.2a1 1 0 1 0 0-2h-1.95l.276-2.21a1 1 0 1 0-1.985-.247L9.367 5H7.383l.276-2.21a1 1 0 0 0-1.985-.247L5.367 5h-2.7a1 1 0 1 0 0 2h2.45l-.25 2h-2.2a1 1 0 0 0 0 2h1.95l-.276 2.21ZM9.118 7H7.133l-.25 2h1.984l.25-2Z"
      clipRule="evenodd"
    />
  </svg>
)
